import Swiper from 'swiper/bundle';

export const initFadeSlider = () => {
  const slider = document.getElementById('js-fade-slider');

  if (!slider) return;

  new Swiper(slider, {
    effect: 'fade',
    loop: true,
    speed: 500,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
  });
};